import { useState, useEffect } from "react";
import { ReactTableDataGrid } from "components/Table";

const limit = 10;
const TablePrinter = ({ data, tableName = "" }) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        if (data) {
            setList(data?.slice(0, limit));
        }
    }, [data]);

    const columns = [
        {
            field: "_id",
            width: 40,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            sortable: false,
        },
        {
            field: "printer",
            headerName: "Printer",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
        },
        {
            field: "count",
            headerName: "Total",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
        },
    ];

    const onTableChanged = ({ page }) => {
        const startIndex = (page - 1) * limit;
        setList(data.slice(startIndex, startIndex + limit));
    };

    return (
        <ReactTableDataGrid
            idProperty="_id"
            tableName={tableName}
            columns={columns}
            height={350}
            rowData={list}
            gridOptions={{
                rowHeight: 80,
                reactiveCustomComponents: true,
            }}
            paginationPageSize={limit}
            totalSize={data?.length || 0}
            emptyText={"No data!"}
            rowSelection="multiple"
            onTableChanged={onTableChanged}
            isSearchText={false}
        />
    );
};

export default TablePrinter;
